var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "verificode-wrap"
  }, [_c('div', {
    staticClass: "code-wrap",
    class: {
      mb: _vm.mb
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.code,
      expression: "code"
    }],
    staticClass: "input code",
    class: {
      mb: _vm.mb,
      changeb: _vm.code
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t(_vm.$loginLangPrefix(_vm.inputCodePlaceholder))
    },
    domProps: {
      "value": _vm.code
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.next();
      },
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.code = $event.target.value;
      }, _vm.codeInput],
      "blur": _vm.codeBlur
    }
  }), _vm._v(" "), _vm.codeSrc ? _c('img', {
    staticClass: "codeimg",
    class: {
      mb: _vm.mb
    },
    attrs: {
      "src": _vm.codeSrc
    },
    on: {
      "click": function click($event) {
        return _vm.getVerify();
      }
    }
  }) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };